<template>
  <div v-if="active">
    <slot />
  </div>
</template>


<script>
export default {
  name: 'MobileTabContent',
  data() {
    return {
      active: false
    }
  },
  inject: {
    mobileTabbedPage: {
      default() {
        return { }
      }
    }
  },
  mounted() {
    this.registerTabContentItem()
  },
  destroyed() {
    this.unregisterTabContentItem()
  },
  methods: {
    registerTabContentItem() {
      this.mobileTabbedPage.registerTabContentItem && this.mobileTabbedPage.registerTabContentItem(this)
    },
    unregisterTabContentItem() {
      this.mobileTabbedPage.unregisterTabContentItem && this.mobileTabbedPage.unregisterTabContentItem(this)
    },
  }
}
</script>